export default __webpack_public_path__ + "static/media/icon-notification.50f0fbd4.png";